'use client';

import React from 'react';
import Image from 'next/image';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useLocale } from 'next-intl';
import { Link, usePathname } from '@/src/i18n/navigation';
import { trackEvent } from '@/src/lib/amplitude';
import { AmplitudeEventProperties } from '@/src/lib/amplitude/events';

interface DynamicLinkProps {
  href: string;
  imageSrc: string;
  imageAlt: string;
  text: string;
  amplutideEvent?: keyof AmplitudeEventProperties;
}

const DynamicLink: React.FC<DynamicLinkProps> = ({
  href,
  imageSrc,
  imageAlt,
  text,
  amplutideEvent,
}) => {
  const currentLanguage = useLocale();
  const pathname = usePathname();
  const isCurrentPage = pathname === href;

  const handleClick = () => {
    if (amplutideEvent) {
      trackEvent(amplutideEvent);
    }
  };

  return (
    <Link href={href} className="w-full" onClick={handleClick}>
      <div className="flex justify-between gap-2 py-3">
        <div className="flex gap-2">
          <Image
            src={imageSrc}
            alt={imageAlt}
            width={20}
            height={20}
            className={`h-5 w-5 ${isCurrentPage ? 'opacity-100' : 'opacity-50'}`}
          />
          <h2
            data-id={text}
            className={`${isCurrentPage ? 'text-primary font-bold' : 'text-primary/70'}`}
          >
            {text}
          </h2>
        </div>
        <div>
          {currentLanguage === 'en' ? (
            <ChevronRight
              className={`${isCurrentPage ? 'text-primary font-bold' : 'text-[#E7E7E8]'}`}
            />
          ) : (
            <ChevronLeft
              className={`${isCurrentPage ? 'text-primary font-bold' : 'text-[#E7E7E8]'}`}
            />
          )}
        </div>
      </div>
    </Link>
  );
};

export default DynamicLink;
